import { FC, useEffect, useState } from "react";
import { Control, FieldValues } from "react-hook-form";

import {
  FormController,
  MuiBox,
  MuiGrid,
  MuiSelect,
} from "../../../../../../../../../../../components";
import MeasurementInput from "../../../../../../../../../../../components/measurementInput/MeasurementInput";
import { useGridContainer } from "../../../../../../../../../../../hooks/useGridContainer";
import { useNavigationSiteCore } from "../../../../../../../../../../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../../../../../../../../../../hooks/useSiteCore";
import {
  ProjectCreateActivityDefaultFormKeys,
  ProjectCreateActivityDefaultProps,
} from "../../../modelsAndSchemas/models";
import { defaultActivityValuesSiteCoreKeys } from "../../../siteCore/SiteCoreKeys";
interface ProjectCreateActivityDefaultTabProps extends FieldValues {
  control: Control<ProjectCreateActivityDefaultProps>;
  pageId: string;
  unitValue?: string;
  isFrameworkActivity?: boolean;
}

export const ProjectCreateActivityDefault: FC<
  ProjectCreateActivityDefaultTabProps
> = ({ control, pageId, unitValue = "", isFrameworkActivity = false }) => {
  const { gridSizeMedium: gridSize, gridSizeMediumClass } =
    useGridContainer(true);
  const { commonLabels, fetchLabel, fetchDropdownValues } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const [newSelectedUnit, setNewSelectedUnit] = useState<string>("");

  useEffect(() => {
    setNewSelectedUnit(unitValue);
  }, [unitValue]);

  // Handle change in unit selection
  const onClickUnitChange = (value: string) => {
    setNewSelectedUnit(value);
  };

  return (
    <MuiBox data-testid="activity-tab-default">
      <MuiGrid container className="activity-tab-default">
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <FormController
            control={control}
            name={ProjectCreateActivityDefaultFormKeys.units}
          >
            <MuiSelect
              disabled={isFrameworkActivity}
              label={fetchLabel(
                defaultActivityValuesSiteCoreKeys.defaultActivityValues,
                defaultActivityValuesSiteCoreKeys.units,
              )}
              options={fetchDropdownValues(
                defaultActivityValuesSiteCoreKeys.defaultActivityValues,
                defaultActivityValuesSiteCoreKeys.unitLists,
              )}
              visibleDefaultSelectOption
              value=""
              id={`${pageId}-${ProjectCreateActivityDefaultFormKeys.units}`}
              isMandatory
              placeholder={commonLabels.selectPlaceHolder}
              onChange={(e) => onClickUnitChange(e.target.value as string)}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        </MuiGrid>
        <MuiGrid size={gridSize} className={gridSizeMediumClass}>
          <MeasurementInput
            disabled={isFrameworkActivity}
            selectedUnit={newSelectedUnit}
            measurementOtherMinuteName={
              ProjectCreateActivityDefaultFormKeys.measurementMinute
            }
            measurementOther={
              ProjectCreateActivityDefaultFormKeys.measurementOther
            }
            control={control}
            pageId={pageId}
            parentKey={defaultActivityValuesSiteCoreKeys.defaultActivityValues}
            minutesLabelKey={defaultActivityValuesSiteCoreKeys.minutes}
            quantityLabelKey={defaultActivityValuesSiteCoreKeys.quantity}
            daysLabelKey={defaultActivityValuesSiteCoreKeys.numberOfDays}
            minuteListKey={defaultActivityValuesSiteCoreKeys.minutesList}
          />
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
